import { ProfanityWord } from "../models/profanityWord";
import { APIVersion, AuthenticatedRequest, HTTPMethod } from "../requests/request";

export class API {

    /**
     * Returns the full profanity blocklist (manager only)
     */
    public static getWords(): Promise<ProfanityWord[]> {
        let apiReqest = new AuthenticatedRequest<ProfanityWord>('/profanity', HTTPMethod.GET, APIVersion.v1_0);
        return apiReqest.send(ProfanityWord).then((response) => {
            return <ProfanityWord[]>response.data
        })
    }

    /**
     * Adds one or more words to the blocklist (manager only).
     * `word` may be a single word or a comma/semicolon/newline separated list.
     * Returns which words were added and which were skipped (already present).
     */
    public static addWords(word: string): Promise<{ added: string[]; skipped: string[] }> {
        let apiReqest = new AuthenticatedRequest<any>('/profanity', HTTPMethod.POST, APIVersion.v1_0, undefined, { word });
        return apiReqest.send().then((response) => {
            return response.data as { added: string[]; skipped: string[] }
        })
    }

    /**
     * Removes a word from the blocklist (manager only)
     */
    public static deleteWord(id: string): Promise<{}> {
        let apiReqest = new AuthenticatedRequest<{}>(`/profanity/${id}`, HTTPMethod.DELETE, APIVersion.v1_0);
        return apiReqest.send().then((response) => {
            return <{}>response.data
        })
    }
}
